import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { NotificationsContext } from './Notifications';

export const withNotifications =
  () =>
  <P extends {}>(WrappedComponent: React.LegacyComponentTypeWithChildren) => {
    return class Wrapper extends React.LegacyComponentWithChildren<P> {
      static displayName = `withNotifications(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

      static contextTypes = {
        executeAction: PropTypes.func,
        getStore: PropTypes.func,
      };

      declare context: LegacyContextType<typeof Wrapper.contextTypes>;

      render() {
        return (
          <NotificationsContext.Consumer>
            {(notificationContext) => {
              const { notify, notificationQueue } = notificationContext;
              return <WrappedComponent notify={notify} notificationQueue={notificationQueue} {...this.props} />;
            }}
          </NotificationsContext.Consumer>
        );
      }
    };
  };

export default withNotifications;
